export default "__VITE_ASSET__C_Se8xaJ__"